const showAnswerText = 'Посмотреть ответ';
const hideAnswerText = 'Спрятать ответ';

const showRiddleAnswerClass = 'show-answer';

class Brainteaser {
    constructor(element) {
        this.answerButton = element.querySelector('.riddle__answer');
        this.answerButton.innerHTML = showAnswerText;
        this.answerButton.style['user-select'] = 'none';

        this.answerText = this.answerButton.getAttribute('value');
        if (this.answerText === null || this.answerText === '') {
            this.answerText = hideAnswerText;
        }

        this.answerButton.addEventListener('click', event => this.onAnswerButtonClick(event));
    }

    resize(pageWidth) {}

    onAnswerButtonClick(event) {
        event.preventDefault();

        const isAnswerVisible = this.answerButton.classList.contains(showRiddleAnswerClass);
        
        this.answerButton.innerHTML = isAnswerVisible ? showAnswerText : this.answerText;
        this.answerButton.classList.toggle(showRiddleAnswerClass);       
        
        if (isAnswerVisible) {
            this.hideAnswer();
        } else {
            this.showAnswer();
        }
    }

    showAnswer() {}
    hideAnswer() {}
} 

class BrainteaserHasAnswerImage extends Brainteaser {
    constructor(element) {
        super(element);

        this.imagesBlock = element.querySelector('.riddle__image-answer-block');

        this.questionImage = element.querySelector('.riddle__image-answer-block__question');
        this.questionImage.addEventListener('click', event => this.onAnswerButtonClick(event));

        this.answerImage = element.querySelector('.riddle__image-answer-block__answer');
        this.answerImage.addEventListener('click', event => this.onAnswerButtonClick(event));

        this.imageSize = {
            width: Number(element.getAttribute('data-image-width')),
            height: Number(element.getAttribute('data-image-height')),
            maxWidth: Number(element.getAttribute('data-image-max-width')),
            coef: 1,
        };

        this.hasImage = this.imageSize.width > 0 && this.imageSize.height > 0;

        if (this.hasImage) {
            this.imageSize.coef = this.imageSize.width / this.imageSize.height;
        }

        let imageClass = null;
        switch (this.imageSize.coef) {
            case 2:
                imageClass = 'img-600-300';
                break;        

            case 1:
                imageClass = 'img-600-600';
                break; 
                
            case 1.5:
                imageClass = 'img-600-400';
                break;                         
        }

        if (imageClass !== null) {
            this.questionImage.classList.add(imageClass);
            this.answerImage.classList.add(imageClass);

            setTimeout(() => {
                this.questionImage.classList.add('loaded');
                this.answerImage.classList.add('loaded');
            }, 0);
        }
    }      
    
    resize(pageWidth) {
        super.resize(pageWidth);

        if (! this.hasImage) {
            return;
        }

        const coef = pageWidth / this.imageSize.width;

        let width = Math.floor(this.imageSize.width * coef);
        if (width > this.imageSize.maxWidth) {
            width = this.imageSize.maxWidth;
        }

        const height = Math.floor(width / this.imageSize.coef);

        this.setElementSize([
            this.imagesBlock,
            this.questionImage,
            this.answerImage,
        ], { width, height });
    }

    setElementSize(elements, size) {
        for (const element of elements) {
            element.style.width = size.width + 'px';
            element.style.height = size.height + 'px';
        }
    }

    showAnswer() {
        super.showAnswer();

        this.imagesBlock.classList.add(showRiddleAnswerClass);
    }

    hideAnswer() {
        super.hideAnswer();

        this.imagesBlock.classList.remove(showRiddleAnswerClass);
    }            
}

class Brainteasers {
    constructor() {
        this.items = [];
        this.page = document.querySelector('.riddles-page');
        this.resizeTimer = null;

        this.load();

        this.resize();

        window.addEventListener('resize', () => this.onWindowResize());
    }

    load() {
        const elements = document.getElementsByClassName('riddle-brainteaser');
        for (const element of elements) {
            const hasAnswerImage = element.getAttribute('data-has-answer-image') === 'true';

            this.items.push(hasAnswerImage ? new BrainteaserHasAnswerImage(element) : new Brainteaser(element));
        }
    }

    onWindowResize() {
        if (this.resizeTimer !== null) {
            clearTimeout(this.resizeTimer);
            this.resizeTimer = null;
        }

        this.resizeTimer = setTimeout(() => {
            this.resize();
            this.resizeTimer = null;
        }, 50); 
    }

    resize() {
        const pageWidth = this.page.offsetWidth;

        for (const item of this.items) {
            item.resize(pageWidth);
        }
    }
}

window.addEventListener('load', () => {
    const brainteasers = new Brainteasers();

    document.querySelectorAll('[data-anchor]').forEach(link => {
        link.addEventListener('click', function(event) {
            event.preventDefault();

            const href = this.getAttribute('data-anchor');
            const scrollTarget = document.getElementById(href);

            if (scrollTarget) {
                //const topOffset = document.querySelector('.some-class').offsetHeight;
                const topOffset = 0;
                const elementPosition = scrollTarget.getBoundingClientRect().top;
                const offsetPosition = elementPosition - topOffset;

                window.scrollBy({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        });
    }); 

    const btnConfirmCookies = document.getElementById('btnConfirmCookies');
    if (btnConfirmCookies) {
        btnConfirmCookies.addEventListener('click', event => {
            event.preventDefault();

            const expires = new Date(new Date() * 1 + 365 * 100 * 864e+5);
            const cookie = 'ks_allowcookies=true; SameSite=Lax; expires=' + expires.toUTCString() + '; secure';
            document.cookie = cookie;

            document.body.classList.remove('body-allow-cookies');

            const cookiesPanel = document.getElementById('cookiesPanel');
            if (cookiesPanel) {
                cookiesPanel.classList.add('hidden');
            }
        });
    }
});